import format from "date-fns/format"
import parseISO from "date-fns/parseISO"
import PropTypes from "prop-types"
import React from "react"

import Form from "../../components/Form"
import { CONFIGURATION_FIELD_TYPES } from "./constants"

const parseDateConfigValue = (value) => {
  if (!value) return null
  // parseISO treats the string as local midnight, avoiding UTC offset issues
  const date = parseISO(value)
  return isNaN(date) ? null : date
}

const formatDateToISO = (date) => (date ? format(date, "yyyy-MM-dd") : "")

const ConfigurationField = ({
  configuration,
  rawValue,
  onUpdate,
  disabled,
}) => {
  switch (configuration.field_type) {
    case CONFIGURATION_FIELD_TYPES.DATE:
      return (
        <Form.DatePicker
          value={parseDateConfigValue(rawValue)}
          onChange={(date) =>
            onUpdate(configuration.key, formatDateToISO(date))
          }
          id={configuration.key}
          disabled={disabled}
          isClearable
        />
      )
    case CONFIGURATION_FIELD_TYPES.SELECT:
    default:
      return (
        <Form.Select
          value={rawValue}
          onChange={(event) => onUpdate(configuration.key, event.target.value)}
          id={configuration.key}
          disabled={disabled}
        >
          <option disabled={configuration.required} value="">
            {configuration.required
              ? `Select ${configuration.label}`
              : `No ${configuration.label}`}
          </option>
          {(configuration.options ?? []).map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Form.Select>
      )
  }
}

ConfigurationField.propTypes = {
  configuration: PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    field_type: PropTypes.string.isRequired,
    required: PropTypes.bool,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.any.isRequired,
        label: PropTypes.string.isRequired,
      })
    ),
  }).isRequired,
  rawValue: PropTypes.string.isRequired,
  onUpdate: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

export default ConfigurationField
